export default "__VITE_ASSET__Bt07RB_S__"